/**
 * タグ
 */
import { brandColors } from '@src/assets/colors/brandColors';
import SvgIconClose from '@src/assets/images/common/icon/close/SvgIconClose';
import React from 'react';

type Props = {
  text: string;
  variant?: 'default' | 'gray';
  index: number;
  onClick: (index: number) => void;
};

const Tag: React.FC<Props> = ({ text, variant = 'default', index, onClick }) => {
  const tagParentClass =
    variant === 'gray'
      ? 'bg-gray-150'
      : 'border border-solid border-gray-250 bg-white  text-primary-400';
  return (
    <div
      className={`flex min-w-0 items-center gap-[8px] rounded-full px-[16px] py-[6px] ${tagParentClass}`}
    >
      <div className='min-w-0 truncate'>
        <div className='truncate text-xs'>{text}</div>
      </div>
      <button
        className='shrink-0'
        type='button'
        onClick={() => onClick(index)}
      >
        <SvgIconClose
          color={variant === 'gray' ? '#292929' : brandColors['500']}
          style={{
            width: '14px',
            height: '14px',
          }}
        />
      </button>
    </div>
  );
};

export default Tag;
